export class CopyEngagement {
    zones: number[];
    newExerciseId: number;
    oldExerciseId: number;
    cutOffDate: string;
    lastCourse: number;
}
